"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const firestore_1 = require("@react-query-firebase/firestore");
const firestore_2 = require("firebase/firestore");
const keyFactory_1 = require("../../Firestore-Query/keyFactory");
/**
 *
 * @param country país
 * @param firestore
 * @param plan tipo de plan, son los que se encuentran en `parametros/${country}/subscription/${plan}`
 * @param options
 * @param queryOptions
 * @returns información del plan
 * @deprecated ya no se utiliza
 */
function usePlanInfo(firestore, plan, options, queryOptions) {
    const planInfoReference = (0, firestore_2.doc)(firestore, `parametros/${plan.country}/subscription/${plan.plan}`);
    return (0, firestore_1.useFirestoreDocumentData)(keyFactory_1.FirestoreKeys.Suscription({
        name: "suscription plan",
        path: `parametros/${plan.country}/subscription/${plan.plan}`
    }, [plan.country, plan.plan]), planInfoReference, options, queryOptions);
}
exports.default = usePlanInfo;
